import i18n from '@/i18n';
import {
  SelectModel,
  SelectBoolModel,
  SelectNumberModel,
  MaestroMesa,
  MaestroEstrategia,
  MaestroProducto,
} from '@/models/repsol-template.model';
import { LoaderState } from '@/store/modules/loader';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UserIdentityModel } from '@/models/file-entities.model';
import store from '@/store';
import { tUi } from '@/utils/translate';

const httpStore = namespace('httpStore');
const loaderStore = namespace('loader');
const notificationState = namespace('notificationState');

@Component({
  name: 'ComponentBase',
})
export default class ComponentBase extends Vue {
  @httpStore.Action
  post!: (payload: any) => Promise<any>;
  @httpStore.Action
  get!: (payload: any) => Promise<any>;
  @httpStore.Action
  put!: (payload: any) => Promise<any>;
  @httpStore.Action
  delete!: (payload: any) => Promise<any>;

  @loaderStore.Mutation
  setLoader!: (payload: boolean) => void;
  @loaderStore.Mutation
  setMsgLoader!: (payload: LoaderState) => void;

  maestroCierreIntegracionEstados: SelectModel[];
  maestroCierreEstado: SelectModel[];
  maestroConsolidadoNeteoDetalleEjecucionTipo: SelectModel[];
  maestroMercado: SelectModel[];

  maestroMesa: SelectModel[];
  maestroMesaContraparte: SelectModel[];
  maestroMesaEscritura: SelectModel[];
  maestroMesaBase: MaestroMesa[];

  maestroOperacionEstado: SelectModel[];
  maestroOperacionTipo: SelectModel[];
  maestroPerfil: SelectModel[];
  maestroProductoEscritura: MaestroProducto[];
  maestroProducto: MaestroProducto[];

  maestroEstrategiaEscritura: MaestroEstrategia[];
  maestroEstrategiaBase: MaestroEstrategia[];

  maestroUsuario: SelectModel[];
  maestroOperador: SelectModel[];
  configuracionMaestros: any;
  userIdentity: UserIdentityModel;

  maestroNotificaciones: SelectModel[];

  maestroSiNo: SelectBoolModel[] = [
    { id: true, nombre: 'common.si' },
    { id: false, nombre: 'common.no' },
  ];

  maestrosLinea: SelectNumberModel[] = [
    { id: 1, nombre: 'common.january' },
    { id: 2, nombre: 'common.february' },
    { id: 3, nombre: 'common.march' },
    { id: 4, nombre: 'common.april' },
    { id: 5, nombre: 'common.may' },
    { id: 6, nombre: 'common.june' },
    { id: 7, nombre: 'common.july' },
    { id: 8, nombre: 'common.august' },
    { id: 9, nombre: 'common.september' },
    { id: 10, nombre: 'common.october' },
    { id: 11, nombre: 'common.november' },
    { id: 12, nombre: 'common.december' },
  ];

  maestroEstrategiaLinea: SelectNumberModel[] = [
    { id: 1, nombre: 'common.first_line' },
    { id: 2, nombre: 'common.second_line' },
  ];

  constructor() {
    super();
    this.userIdentity = (store.state as any).userIdentity
      .userIdentity as UserIdentityModel;

    this.maestroCierreEstado = [];
    this.maestroCierreIntegracionEstados = [];
    this.maestroConsolidadoNeteoDetalleEjecucionTipo = [];
    this.maestroMercado = [];
    this.maestroMesa = [];
    this.maestroMesaContraparte = [];
    this.maestroMesaBase = [];
    this.maestroMesaEscritura = [];
    this.maestroOperacionEstado = [];
    this.maestroOperacionTipo = [];
    this.maestroPerfil = [];
    this.maestroEstrategiaEscritura = [];
    this.maestroEstrategiaBase = [];
    this.maestroUsuario = [];
    this.maestroProductoEscritura = [];
    this.maestroProducto = [];
    this.maestroNotificaciones = [];
    this.configuracionMaestros = {
      estrategia: {
        url: '/api/maestro/estrategia',
        modelo: this.maestroEstrategiaBase,
      },
      mercado: {
        url: '/api/maestro/mercado',
        modelo: this.maestroMercado,
      },
      cierreEstado: {
        url: '/api/maestro/cierreEstado',
        modelo: this.maestroCierreEstado,
      },

      cierreIntegracionEstados: {
        url: '/api/maestro/cierreIntegracionEstados',
        modelo: this.maestroCierreIntegracionEstados,
      },
      consolidadoNeteoDetalleEjecucionTipo: {
        url: '/api/maestro/consolidadoNeteoDetalleEjecucionTipo',
        modelo: this.maestroConsolidadoNeteoDetalleEjecucionTipo,
      },
      mesa: {
        url: '/api/maestro/mesa',
        modelo: this.maestroMesaBase,
      },
      operacionEstado: {
        url: '/api/maestro/operacionEstado',
        modelo: this.maestroOperacionEstado,
      },
      operacionTipo: {
        url: '/api/maestro/operacionTipo',
        modelo: this.maestroOperacionTipo,
      },
      perfil: {
        url: '/api/maestro/perfil',
        modelo: this.maestroPerfil,
      },
      producto: {
        url: '/api/maestro/producto',
        modelo: this.maestroProducto,
      },
      usuario: {
        url: '/api/maestro/usuario',
        modelo: this.maestroUsuario,
      },     
      notificacion: {
        url: '/api/maestro/Notificaciones',
        modelo: this.maestroNotificaciones,
      },
    };
  }

  getEstrategias(anio: number): SelectNumberModel[] {
    return this.maestroEstrategiaEscritura.filter(
      (e) =>
        e.anioDesde <= anio && (e.anioHasta == undefined || e.anioHasta >= anio)
    );
  }

  async getMaestroEstrategia() {
    await this.getMaestro('estrategia');
    this.maestroEstrategiaBase
      .filter((m) => m.mesaAutorizada)
      .forEach((m) => this.maestroEstrategiaEscritura.push(m));
  }
  async getMaestroCierreEstado() {
    await this.getMaestro('cierreEstado');
  }

  async getMaestroCierreIntegracionEstados() {
    await this.getMaestro('cierreIntegracionEstados');
  }
  async getMaestroConsolidadoNeteoDetalleEjecucionTipo() {
    await this.getMaestro('consolidadoNeteoDetalleEjecucionTipo');
  }
  async getMaestroMercado() {
    await this.getMaestro('mercado');
  }
  async getMaestroMesa() {
    await this.getMaestro('mesa');
    this.maestroMesaBase
      .filter((m) => !m.esContraparte)
      .forEach((m) => this.maestroMesa.push(m));
    this.maestroMesaBase
      .filter((m) => m.esContraparte)
      .forEach((m) => this.maestroMesaContraparte.push(m));
    this.maestroMesaBase
      .filter((m) => !m.soloLectura)
      .forEach((m) => this.maestroMesaEscritura.push(m));
  }
  async getMaestroOperacionEstado() {
    await this.getMaestro('operacionEstado');
  }
  async getMaestroOperacionTipo() {
    await this.getMaestro('operacionTipo');
  }
  async getMaestroPerfil() {
    await this.getMaestro('perfil');
  }
  async getMaestroProducto() {
    await this.getMaestro('producto');
    this.maestroProducto
      .filter((m) => !m.soloLectura)
      .forEach((m) => this.maestroProductoEscritura.push(m));
  }
  async getMaestroUsuario() {
    await this.getMaestro('usuario');
  }
  async getMaestroOperador() {
    await this.getMaestro('operador');
  }

  async getMaestroNotificaciones() {
    await this.getMaestro('notificacion');
  }

  async getMaestro(tipo: string) {
    const config = this.configuracionMaestros[tipo];
    if (!config) {
      return;
    }
    return this.get({ apiUrl: config.url }).then((data) => {
      if (!data) {
        return;
      }
      //config.modelo.length = 0;
      for (let i = 0; i < data.length; i++) {
        config.modelo.push(data[i]);
      }
    });
  }
  openSpinner(msg: string) {
    this.setMsgLoader({
      isLoading: true,
      messageLoading: msg,
    });
  }

  closeSpinner() {
    this.setLoader(false);
  }

  mostrarOK(msg: string) {
    Vue.$toast.success(i18n.t(msg));
  }

  t(message: string, params?: Record<string, unknown>): string {
    return i18n.t(message, params).toString();
  }

  tUi(message: string, params?: Record<string, unknown>): string {
    return tUi(message, params);
  }

  mostrarKO(msg: string) {
    Vue.$toast.error(i18n.t(msg));
  }

  mostrarAdvertencia(msg: string, opciones?: Record<string, any>) {
    Vue.$toast.warning(i18n.t(msg));
  }

  minLen(min: number) {
    return (field: string) =>
      (!!field && Number(field) >= min) ||
      this.$t('validations_form.minLen') + ' ' + min; //El tamaño minimo requiero es:
  }

  maxLen(max: number) {
    return (field: string) =>
      (!!field && field.length <= max) ||
      this.$t('validations_form.maxLen') + ' ' + max; //El tamaño maximo requiero es:
  }

  range(min: number, max: number) {
    return (field: number) =>
      (field >= min && field <= max) ||
      this.$t('validations_form.range') + ` ${min} - ${max}`;
  }

  required() {
    return (field: string) => !!field || this.$t('validations_form.required');
  }

  maxLimit(max: number) {
    return (field: number) => {
      if (this.userIdentity && this.userIdentity.perfilId !== 'ADM') {
        return field <= max || this.$t('validations_form.cantidadLimiteSuperior', { limiteSuperior: max });
      } else {
        // Perfil de administrador, no hay restricciones de límite máximo
        return true;
      }
    };
  }

  validarEmail() {
    return (field: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(field) || this.$t('validations_form.invalidEmail');
    };
  }

  traducirMaestros(maestro: any[], id: any) {
    if (!maestro) {
      return id;
    }

    const traduccionAutomatico =
      maestro.find((item) => item.id === id)?.nombre || id;
    return tUi(String(traduccionAutomatico));
  }
}
